import './loginModule.scss'

import LoginModule from './containers/loginModule'

export { default as LoginModuleLayout } from './components/loginModuleLayout'

export default LoginModule
